module.exports = __webpack_public_path__ + "static/img/no5.16fc910.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/awardTW/img/no5.png
// module id = aPte
// module chunks = 1